import React from 'react';

export default class SearchInput extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="search-input">
        <div className="form-group">
          <span className="fa fa-search" />
          <input type="text" className="form-control" placeholder={I18n.t('search') + I18n.t('ellipsis')} value={this.props.value} onInput={this.props.onChange} />
          {this.props.value && this.props.value !== "" ? <span className="fa fa-times" onClick={() => this.props.onChange({target: { value: ""}})} /> : null}
        </div>
      </div>
    );
  };
};
